<template>
    <v-container class="full-height">
        <iframe :src="iframeUrl" width="100%" height="100%" frameborder="0"></iframe>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "LyndusPass",
    computed: {
        ...mapGetters(["userData", "currentUser"]),
        iframeUrl() {
            // Default URL
            let baseUrl = "";
            // Change path based on user
            if (this.currentUser.includes('PRZYBYSZEWSKI')) {
                baseUrl = `https://cezar.lyndus.com.br`;
            } else if (this.currentUser.includes('ADVENTUS') && this.currentUser.includes('COLOMBO')) {
                baseUrl = `https://adventus-colombo.lyndus.com.br`;
            } else if (this.currentUser.includes('ADVENTUS') && this.currentUser.includes('CWB')) {
                baseUrl = `https://adventus-santacandida.lyndus.com.br`;
            } else if (this.currentUser.includes('AUGUSTO') && this.currentUser.includes('GRANDI')) {
                baseUrl = `https://grandi-barber.lyndus.com.br`;
            } else if (this.currentUser.includes('EDLINGE')){
                baseUrl = `https://dl-barber.lyndus.com.br`;
            } else if (this.currentUser.includes('GERSON')){
                baseUrl = `https://elegant.lyndus.com.br`;
            }
            
            return `${baseUrl}/bs`;
        }
    }
};
</script>

<style scoped>
.full-height {
    height: 90vh;
    display: flex;
    flex-direction: column;
}

iframe {
    flex: 1;
    border: none;
}
</style>